import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    targetData: {
        aging_target_action: 0,
        aging_target_review: 0
    },
    isLoading: false,
    error: "",
    successMessage: ""
};

const agingTargetSlice = createSlice({
    name: 'agingTarget',
    initialState,
    reducers: {
        setAgingTargets: (state, action) => {
            state.targetData = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        clearAgingTargets: (state) => {
            state.targetData = {
                aging_target_action: 0,
                aging_target_review: 0,
            };
            state.isLoading = false;
            state.error = "";
            state.successMessage = "";
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        clearError: (state) => {
            state.error = ""
        },
        setLoading: (state) => {
            state.isLoading = true;
        },
        setSuccess: (state, action) => {
            state.successMessage = action.payload;
            state.isLoading = false;
        },
        clearSuccess: (state) => {
            state.successMessage = ""
        }
    },
});

export const {
    setAgingTargets,
    setError,
    clearError,
    setLoading,
    setSuccess,
    clearSuccess,
    clearAgingTargets
} = agingTargetSlice.actions;

export const fetchTargets = (clientId, accessToken) => async (dispatch) => {
    dispatch(setLoading());
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/email/${clientId}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        const data = response.data;
        dispatch(setAgingTargets({
            aging_target_action: data.data.aging_target_action,
            aging_target_review: data.data.aging_target_review
        }));
    } catch (error) {
        console.log(error.response.data.message);
    }
};

export const saveTargets = (data, accessToken) => async (dispatch) => {
    dispatch(setLoading());
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_BASE_URL}/email`,
            data,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${accessToken}`
                }
            }
        );
        const result = response.data;

        dispatch(setAgingTargets({
            aging_target_action: result.data.aging_target_action,
            aging_target_review: result.data.aging_target_review
        }));
        dispatch(setSuccess('Aging targets saved successfully'));
    } catch (error) {
        console.log("Error message inside save:", error.response.data.message);
        dispatch(setError(error.response.data.message));
    }
};

export const updateTargets = (data, accessToken) => async (dispatch) => {
    dispatch(setLoading());
    try {
        const response = await axios.put(
            `${process.env.REACT_APP_BACKEND_BASE_URL}/email`,
            data,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${accessToken}`
                }
            }
        );

        const result = response.data;

        dispatch(setAgingTargets({
            aging_target_action: result.data.aging_target_action,
            aging_target_review: result.data.aging_target_review
        }));
        dispatch(setSuccess('Aging targets updated successfully'));
    } catch (error) {
        console.log("Error message inside update:", error.response.data.message);
        dispatch(setError(error.response.data.message));
    }
};


export default agingTargetSlice.reducer;